import { createElement, memo, useMemo, useState, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
const colNum = 7;
const MyComponent = (props) => {
    const { citydata, checkedCity: _checkedCity, allCityStyle, _LXReport, _communication } = props;
    const { checkedColor, uncCheckedColor } = allCityStyle;
    const [visible, setVisible] = useState(false);
    const [checkedCity, setCheckedCity] = useState(_checkedCity);
    useEffect(() => {
        setCheckedCity(_checkedCity);
    }, [_checkedCity]);
    const cityList = useMemo(() => {
        const _citydata = [...citydata];
        if (checkedCity) {
            const checkIndex = _citydata.findIndex(item => item.value === checkedCity.value);
            _citydata.splice(checkIndex, 1);
            _citydata.unshift(checkedCity);
            _citydata.splice(colNum - 1, 0, {
                title: visible ? "收起" : "展开",
                value: '-1',
                isButton: true
            });
        }
        if (visible)
            return _citydata;
        return _citydata.slice(0, colNum);
    }, [visible, citydata, checkedCity]);
    useEffect(() => {
        setCheckedCity(checkedCity);
    }, [checkedCity]);
    const handleClick = (data) => {
        if (data.isButton) {
            setVisible(!visible);
        }
        else {
            handleCityChange(data);
            _communication === null || _communication === void 0 ? void 0 : _communication.emit('cityChanged', data);
        }
    };
    const handleCityChange = (city) => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport('b_daodian_lowcode_s1i934ut_mc', {
            valLab: {
                item_name: city === null || city === void 0 ? void 0 : city.title,
                item_index: city === null || city === void 0 ? void 0 : city.value
            }
        });
        setCheckedCity(city);
        setVisible(false);
    };
    const renderCityItem = (data, index) => <View className="city_horizontal_text_card">
            <Text className='city_horizontal_text_card_text' style={{
        color: index === 0 ? checkedColor : uncCheckedColor,
        borderLeft: !data.isButton && index % colNum !== 0 ? '3rpx solid' : 'none',
        borderLeftColor: uncCheckedColor
    }} onClick={() => handleClick(data)}>
                {data === null || data === void 0 ? void 0 : data.title}
            </Text>
        </View>;
    return <View className='city_horizontal_text'>
            {cityList.map((item, index) => renderCityItem(item, index))}
        </View>;
};
export default memo(MyComponent);
